
<div :data-component-name="$options.name">
  <div class="h-50 d-inline-block">
    <img v-lazy="jel_getFichierSrc(content.image)" class="w-100" :alt="content.titre" />

    <p v-if="content.surTitre" v-html="content.surTitre"></p>
    <h3>
      <span v-html="content.titre"></span>
    </h3>
    <p v-html="content.sousTitre"></p>
  </div>
  <div class="h-50 d-inline-block" v-html="content.texte"></div>
</div>
